import styled from '@emotion/styled'
import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/css/navigation' // スタイルをインポート
import 'swiper/css/pagination'
import CarouselArrowLeftSvg from '../atoms/carouselArrowLeftSvg'
import CarouselArrowRightSvg from '../atoms/carouselArrowRightSvg'
import useRouteParam from '../../hooks/useRouteParam' // スタイルをインポート

const Wrapper = styled.article`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  .swiper-wrap {
    position: relative;
    width: 600px;
  }

  .swiper-slide {
    height: 90px;

    img {
      width: 285px;
      height: auto;
    }
  }

  .left-button {
    position: absolute;
    left: -35px !important;
    top: 28%;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .right-button {
    position: absolute;
    right: -35px !important;
    top: 28%;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .swiper-button {
    svg {
      color: #243650;
    }
  }

  .swiper-button-disabled {
    svg {
      color: #e5e5e5;
    }
  }

  .swiper-pagination {
    position: relative !important;
    margin-top: 20px !important;
  }

  .swiper-pagination-bullet {
    background-color: #505050;
  }

  .swiper-pagination-bullet-active {
    background-color: #35d4c7;
  }
`

/**
 * コラム下部：カルーセルバナー
 * @constructor
 */
const CarouselBanner = () => {
  SwiperCore.use([Autoplay])
  const prevRef = useRef<HTMLDivElement>(null)
  const nextRef = useRef<HTMLDivElement>(null)
  const routeParam = useRouteParam(
    'https://www.kintaicloud.jp/download/?utm_source=column&utm_medium=banner&utm_campaign=banner_202301'
  )
  const routeParam2 = useRouteParam(
    'https://www.kintaicloud.jp/contact/?utm_source=column&utm_medium=banner&utm_campaign=banner_202301'
  )
  const routeParam3 = useRouteParam(
    'https://www.kintaicloud.jp/benefit/?utm_source=column&utm_medium=banner&utm_campaign=banner_202301'
  )

  return (
    <Wrapper>
      <div className="swiper-wrap">
        <Swiper
          spaceBetween={30}
          slidesPerView={2}
          centeredSlides
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={800}
          loop
          navigation={{
            prevEl: '#button_prev',
            nextEl: '#button_next',
          }}
          pagination={{
            clickable: true,
            el: '#pagination',
          }}
          modules={[Navigation, Pagination]}
        >
          <SwiperSlide>
            <a target="_blank" href={routeParam} rel="noreferrer">
              <img
                src="/images/column/common/carouselBanner01.png"
                alt="資料請求"
              />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a target="_blank" href={routeParam2} rel="noreferrer">
              <img
                src="/images/column/common/carouselBanner02.png"
                alt="お問い合わせ"
              />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a target="_blank" href={routeParam3} rel="noreferrer">
              <img
                src="/images/column/common/carouselBanner03.png"
                alt="導入効果"
              />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=LYobNX9P-BU&utm_source=column&utm_medium=banner&utm_campaign=banner_202301"
              rel="noreferrer"
            >
              <img
                src="/images/column/common/carouselBanner04.png"
                alt="サービス紹介動画"
              />
            </a>
          </SwiperSlide>
        </Swiper>
        <div ref={prevRef} id="button_prev" className="left-button">
          <CarouselArrowLeftSvg color="#243650" />
        </div>
        <div ref={nextRef} id="button_next" className="right-button">
          <CarouselArrowRightSvg color="#243650" />
        </div>
        <div id="pagination" className="swiper-pagination" />
      </div>
    </Wrapper>
  )
}

export default CarouselBanner
